import React, { useEffect, useRef, useState } from "react";
import "../../../../Assets/Styles/Chatbot.scss";
import "../../../../Assets/Styles/Communication.scss";
import ShowSuggestions from "./Components/ShowSuggestions";
import ChatInput from "./Components/ChatInput";
import ChatMessages from "./Components/ChatMessages";
import AutofillComponent from "./Components/Autofill";
import axios from "axios";
import { Config } from "../../../../Config";
import ChatbotHeader from "./Components/ChatbotHeader";
import TypingIndicator from "./Components/TypingIndicator";
import JpaDetailsModal from "./Components/JpaDetailsModal";
import TimeoutModal from "./Components/TimeoutModal";
import SkillSelectNotifier from "./Components/SkillSelectNotifier";

const CXBot = (props) => {
  const translateText = (LabelId) => {
    var Filter = "label_id";
    var Keyword = LabelId;
    var Label = props.LangData.filter((Obj) => {
      return Obj[Filter] === Keyword;
    });
    return Label[0]?.label_value;
  };

  const chatBotElement = useRef();
  const ChatbotTimeRef = useRef(null);
  const ChatbotAlertRef = useRef(null);

  const [showHeaderBanner, setShowHeaderBanner] = useState(
    localStorage.getItem("showChatbotOnBoardingBanner")
  );
  const [headerBannerMessage, setHeaderBannerMEssage] = useState(
    translateText("chatbot_onboarding_banner_text")
  );
  const [suggestion, setSuggestion] = useState({
    //setSuggestion according to server response
    show: false,
    name: "language", //can be language, location, or skills. adjust according to text by server
    input: [
      //adjust based on suggestion given by server
      "English",
      "German",
    ],
    isQuickReplies: false, //will be true if server has quick_replies key
    quickReplies: [
      //quick_replies example response
      {
        content_type: "text",
        title: translateText("yes"),
        payload: "/affirm",
      },
      {
        content_type: "text",
        title: translateText("no"),
        payload: "/deny",
      },
    ],
  });
  const [ConversationMessages, setConversationMessages] = useState([]);
  const [Candidates, setCandidates] = useState({
    show: false,
    isJpa: true,
    showJpaDetails: false,
    list: [],
    jpaList: [],
    savedContents: [],
    jpaDetails: {},
  });
  const [Autofill, setAutofill] = useState({
    isOpen: false,
    type: "LANGUAGE", // can be SKILL, LOCATION, LANGUAGE
    languages: ["English", "German", "Malay", "French"],
    locations: ["London", "New York"],
    skills: [],
    selected_languages: [],
    selected_locations: [],
    selected_skills: [],
  });
  const [AutofillIsOpen, setAutofillIsOpen] = useState(false);
  const [AutofillType, setAutofillType] = useState("LANGUAGE"); // can be SKILL, LOCATION, LANGUAGE, TITLE
  const [AutofillSlotName, setAutofillSlotName] = useState("");
  const [AutofillResults, setAutofillResults] = useState([]);
  const [JPAType, setJPAType] = useState("position");
  const [JPACategoryType, setJPACategoryType] = useState("position"); //position, project, activity
  const [SelectedSkills, setSelectedSkills] = useState([]);
  const [QuickReplyIsOpen, setQuickReplyIsOpen] = useState(false);
  const [QuickReplyMessage, setQuickReplyMessage] = useState([]);
  const [SelectSearchTypeIsOpen, setSelectSearchTypeIsOpen] = useState(false);
  const [SuggestionIsOpen, setSuggestionIsOpen] = useState(false);
  const [SkillSelectionIsDone, setSkillSelectionIsDone] = useState(false);
  const [Recommendations, setRecommendations] = useState([]);
  const [RecommendationListIsOpen, setRecommendationListIsOpen] =
    useState(false);
  const [AdditionalJPAs, setAdditionalJPAs] = useState([]);
  const [ShowMoreJPAsIsOpen, setShowMoreJPAsIsOpen] = useState(false);
  const [IndicatorIsShown, setIndicatorIsShown] = useState(false);
  const [TripleBtnIsShown, setTripleBtnIsShown] = useState(false);
  const [UniqueTitles, setUniqueTitles] = useState([]);
  const [IsLookingForJPA, setIsLookingForJPA] = useState(true);
  const [AdditionalCandidates, setAdditionalCandidates] = useState({
    set_1: [],
    set_2: [],
    set_3: [],
  });
  const [ShowMoreRecommendationsIsOpen, setShowMoreRecommendationsIsOpen] =
    useState(false);
  const [totalRecommendationElements, setTotalRecommendationElements] =
    useState(0);
  const [MoreCandidatesCount, setMoreCandidatesCount] = useState(3);
  const [PlaceholderText, setPlaceholderText] = useState(
    translateText("write_a_message")
  );
  const [SavedRequestId, setSavedRequestId] = useState("");
  const [JPADetailsIsOpen, setJPADetailsIsOpen] = useState(false);
  const [JPAItem, setJPAItem] = useState();
  const [DeviceInfo, setDeviceInfo] = useState(
    window.navigator.userAgent.split(/\(([^)]+)\)/)[1]
  );
  const [ShowMoreJPAIsClicked, setShowMoreJPAIsClicked] = useState(false);
  const [TimeoutDuration, setTimeoutDuration] = useState(10); // the value is in minutes
  const [TimeoutModalIsOpen, setTimeoutModalIsOpen] = useState(false);
  const [TimeoutWarning, setTimeoutWarning] = useState(0);
  const [ErrorMessage, setErrorMessage] = useState({
    IsOpen: false,
    Message: "Please select at least one vacancy, project, or activity.",
  });
  const [ReactionType, setReactionType] = useState(null); // null | like | Applied | apply
  const [NotifierIsShown, setNotofierIsShown] = useState(false);

  useEffect(() => {
    getTimeoutDurations();
  }, []);

  useEffect(() => {
    if (
      PlaceholderText ===
      translateText("chatbot_enter_skill_character", props.LangData)
    ) {
      setNotofierIsShown(true);
    } else {
      setNotofierIsShown(false);
    }
  }, [PlaceholderText]);

  useEffect(() => {
    setPlaceholderText(translateText("write_a_message"));
    setHeaderBannerMEssage(translateText("chatbot_onboarding_banner_text"));
  }, [props.LangData]);

  const restartChatbot = () => {
    let Req = {
      method: "POST",
      baseURL: window._env_.RASA_URL + "/webhooks/rest/webhook",
      headers: {
        "Content-Type": "application/json",
      },
      data: {
        sender: props.UserInfo.id + `(${DeviceInfo})`,
        message: "/restart",
        metadata: { token: window.localStorage.getItem("Token") },
      },
    };

    axios(Req)
      .then((Res) => {
        console.log(Res);
      })
      .catch((Err) => {
        console.log(Err);
      });
  };

  // fetches application general configs
  const getTimeoutDurations = () => {
    let Req = {
      method: "GET",
      baseURL:
        window._env_.API_URL +
        Config.AuthBaseURL +
        "/api/general-config/application-setting/session-timeout",
      headers: {
        Authorization: "Bearer " + window.localStorage.getItem("Token"),
      },
    };
    axios(Req)
      .then((Res) => {
        console.log(Res);

        let ChatbotTimeoutItem = Res.data.filter((Item) => {
          return Item.name === "CHATBOT_SESSION_TIMEOUT_MINUTES";
        });

        let ChatbotWarningTimeoutItem = Res.data.filter((Item) => {
          return Item.name === "CHATBOT_SESSION_TIMEOUT_WARNING_MINUTES";
        });

        setTimeoutDuration(parseInt(ChatbotTimeoutItem[0].value));
        setTimeoutWarning(parseInt(ChatbotWarningTimeoutItem[0].value));
      })
      .catch((Err) => {
        console.log(Err);
      });
  };

  const resetBotTimeouts = () => {
    handleChatbotSessionTimeout();
    handleChatbotSessionTimeoutWarning();
  };

  const handleChatbotSessionTimeout = (Timeout) => {
    if (ChatbotTimeRef.current) {
      clearTimeout(ChatbotTimeRef.current);
    }

    if (!Timeout) {
      Timeout = TimeoutDuration;
    }
    let Duration = Timeout * 60000; // in milliseconds

    ChatbotTimeRef.current = setTimeout(() => {
      endChatbotSession();
    }, Duration);
  };

  const handleChatbotSessionTimeoutWarning = (Timeout) => {
    if (ChatbotAlertRef.current) {
      clearTimeout(ChatbotAlertRef.current);
    }

    if (!Timeout) {
      Timeout = TimeoutWarning;
    }
    let Duration = Timeout * 60000; // in milliseconds

    ChatbotAlertRef.current = setTimeout(() => {
      setTimeoutModalIsOpen(true);
    }, Duration);
  };

  const endChatbotSession = () => {
    setConversationMessages([
      {
        isMe: false,
        content: translateText("chatbot_timeout_message"),
        dateTime: new Date().getTime(),
      },
    ]);
    setAutofillIsOpen(false);
    setRecommendationListIsOpen(false);
    setTotalRecommendationElements(0);
    setQuickReplyIsOpen(false);
    setQuickReplyMessage([]);
    setShowMoreJPAsIsOpen(false);
    setTripleBtnIsShown(false);
    setShowMoreRecommendationsIsOpen(false);
    setSelectSearchTypeIsOpen(false);
    setTimeoutModalIsOpen(false);
    setErrorMessage({ ...ErrorMessage, IsOpen: false });
    setPlaceholderText(translateText("write_a_message"));
    restartChatbot();
  };

  // sending messages is handled by this function
  // WillInform is set to true when we want a n action to
  // happen on the chatbot and the message is not just a text
  const handleInputSubmit = (e, WillInform, Option) => {
    if (e) {
      e.preventDefault();
    }

    var Message = document.getElementById("chatbot-input").value;
    let PayloadMessage;
    if (QuickReplyMessage[0]?.title === Message) {
      PayloadMessage = QuickReplyMessage[0].payload;
    }
    if (QuickReplyMessage[1]?.title === Message) {
      PayloadMessage = QuickReplyMessage[1].payload;
    }
    setQuickReplyMessage([]);

    // saving the last quick reply (yes/no)
    if (PayloadMessage === "/affirm" || PayloadMessage === "/deny") {
      document.getElementById("last-fast-reply").value = Message;
    }

    if (Message.length > 0) {
      // handles sending message to chatbot
      if (!Autofill.isOpen && !Candidates.show) {
        let Req = {
          method: "POST",
          baseURL: window._env_.RASA_URL + "/webhooks/rest/webhook",
          headers: {
            "Content-Type": "application/json",
          },
          data: {
            sender: props.UserInfo.id + `(${DeviceInfo})`,
            message: PayloadMessage ? PayloadMessage : Message,
            metadata: { token: window.localStorage.getItem("Token") },
          },
        };

        if (WillInform) {
          Req.data = {
            sender: props.UserInfo.id + `(${DeviceInfo})`,
            message: '/inform{"jpa_title_selected":"' + Option + '"}',
            metadata: { token: window.localStorage.getItem("Token") },
          };
          if (Option) {
            Message = Option;
          }
        }
        // message: "/inform{\"jpa_title_selected\":\""+ Option +"\"}",
        setTimeout(() => {
          setIndicatorIsShown(true);
        }, 200);
        if (ConversationMessages.length === 0) {
          resetBotTimeouts(); // starts counting the minutes to track deactivity to end session
        }
        setConversationMessages([
          ...ConversationMessages,
          {
            content: Message,
            isMe: true,
            dateTime: new Date().getTime(),
          },
        ]);

        axios(Req)
          .then((Res) => {
            console.log(Res);
            setPlaceholderText(translateText("write_a_message"));
            if (!Res.data[0]) {
              setTimeout(() => {
                axios(Req)
                  .then((Res) => {
                    console.log(Res);
                    handleReceivedMessage(Res.data, Message);
                  })
                  .catch((Err) => {
                    console.log(Err);
                  });
              }, 700);
            } else {
              handleReceivedMessage(Res.data, Message);
            }
          })
          .catch((Err) => {
            console.log(Err);
          });
      }
    }
  };

  // this function handles updating the chat and showing the required buttons after a message is sent by the user
  // and there's a response from the server that will determine what to do next.
  const handleReceivedMessage = (Resp, Message) => {
    document.getElementById("chatbot-input").value = "";

    setAutofillIsOpen(false);
    setRecommendationListIsOpen(false);
    setTotalRecommendationElements(0);
    setQuickReplyIsOpen(false);
    setQuickReplyMessage([]);
    setShowMoreJPAsIsOpen(false);
    setTripleBtnIsShown(false);
    setShowMoreRecommendationsIsOpen(false);
    setSelectSearchTypeIsOpen(false);
    setErrorMessage({ ...ErrorMessage, IsOpen: false });
    setTimeout(() => {
      let NewMessages = [];
      Resp.map((Message) => {
        if (Message.text) {
          NewMessages.push({
            content: Message.text,
            isMe: false,
            dateTime: new Date().getTime(),
          });
          if (Message.buttons) {
            if (Message.buttons.length === 2) {
              if (Message.buttons[0].payload === "/search_vacancy") {
                setSelectSearchTypeIsOpen(true);
              } else {
                // make sure quick reply message is set before showing
                setQuickReplyMessage(Message.buttons);
                setQuickReplyIsOpen(true);
              }
            } else if (Message.buttons.length === 3) {
              setTripleBtnIsShown(true);
            }
          }
        } else if (Message.custom && Message.custom.data.select) {
          setJPAType(Message.custom.data.select.item_type);
          setAutofillIsOpen(true);
          setAutofillType(Message.custom.data.select.item.toUpperCase());
          setAutofillSlotName(Message.custom.data.select.slot_name);
          if (Message.custom.data.select.item === "title") {
            setAutofillResults([]);
            searchTitles(Message.custom.data.select.item_type);
          } else if (Message.custom.data.select.item === "skills") {
            setAutofillResults([]);
            searchSkills();
          } else if (Message.custom.data.select.item === "location") {
            setAutofillResults([]);
            searchLocations();
          } else if (Message.custom.data.select.is_for_vacancy === "False") {
            requestCandidateRecommendations();
            setIsLookingForJPA(true);
          }
        } else if (
          Message.custom &&
          Message.custom.data.info &&
          Message.custom.data.info.info === "jpa_form_filled"
        ) {
          var FinalInfo = JSON.parse(Message.custom.data.info.info_description);
          const RequestId = FinalInfo.filters.request_id;
          setSavedRequestId(RequestId);
          if (FinalInfo.is_for_candidate) {
            setIsLookingForJPA(false);
            requestCandidateRecommendations(RequestId);
          } else {
            setIsLookingForJPA(true);
            requstJPARecommendations(RequestId);
          }
        } else if (
          Message.custom &&
          Message.custom.data.info &&
          Message.custom.data.info.info === "show_me_requested"
        ) {
          const FinalInfo = JSON.parse(
            Message.custom.data.info.info_description
          );
          // reaction_type = position | project | activity
          setReactionType(FinalInfo.reaction_type);
          setJPACategoryType(FinalInfo.category);
          setJPAType(FinalInfo.category);
          if (FinalInfo.reaction_type === "like") {
            requestShowLikedJPA(FinalInfo.category, 0, true);
          }
          if (
            FinalInfo.reaction_type === "Applications" ||
            FinalInfo.reaction_type === "apply"
          ) {
            requestShowAppliedJPA(FinalInfo.category, 0, true);
          }
          // cancelling JPA form in the middle of conversation
        } else if (
          Message.custom &&
          Message.custom.data.info &&
          Message.custom.data.info.info === "jpa_form_canceled"
        ) {
          setSelectedSkills([]);

          setTimeout(() => {
            console.log(ConversationMessages, NewMessages);
            ConversationMessages.map((Item) => {
              if (Item.IsSkill) {
                Item.isTemp = false;
              }
            });
          }, 500);
        }
      });

      setConversationMessages([
        ...ConversationMessages,
        {
          content: Message,
          isMe: true,
          dateTime: new Date().getTime(),
        },
        ...NewMessages,
      ]);

      scrollChat();

      setIndicatorIsShown(false);
    }, 1000);
  };

  const scrollChat = () => {
    let ScrollHeight = document.getElementById("message-items").scrollHeight;
    document.getElementById("message-items").scrollTop = ScrollHeight;
  };

  const sendQuickReply = (Reply) => {
    document.getElementById("chatbot-input").value = Reply;
    document.getElementById("chatbot-send-btn").click();
    setQuickReplyIsOpen(false);
    if (SelectSearchTypeIsOpen) {
      setSelectSearchTypeIsOpen(false);
    }
  };

  const requestCandidateRecommendations = (RequestId) => {
    setIsLookingForJPA(false);
    setPlaceholderText(translateText("write_a_message"));

    let FilterParam = "?ignoreFilter=false";
    //if RequestId is given in function args, then use it
    //else if RequestIs is not given in function args but exist in state, then use SavedRequestId
    //else no need params
    let RequestIdParam = RequestId
      ? `&requestId=${RequestId}`
      : SavedRequestId
      ? `&requestId=${SavedRequestId}`
      : "";
    let ReqURL =
      Config.PositionServiceURL +
      "/api/position/chatbot-candidates" +
      FilterParam +
      RequestIdParam;
    if (JPAType === "project") {
      ReqURL =
        Config.ProjectServiceURL +
        "/api/project/chatbot-candidates" +
        FilterParam +
        RequestIdParam;
    } else if (JPAType === "activity") {
      ReqURL =
        Config.ActivityServiceURL +
        "/api/activity/chatbot-candidates" +
        FilterParam +
        RequestIdParam;
    }

    let Req = {
      method: "GET",
      baseURL: window._env_.API_URL + ReqURL,
      headers: {
        Authorization: "Bearer " + window.localStorage.getItem("Token"),
      },
    };
    axios(Req)
      .then((Res) => {
        console.log(Res);
        handleAfterCandidateRecomActions(Res, RequestId);
      })
      .catch((Err) => {
        console.log(Err);
        if (Err.response.status === 404) {
          setTimeout(() => {
            axios(Req)
              .then((Res) => {
                handleAfterCandidateRecomActions(Res, RequestId);
              })
              .catch((Err) => {
                console.log(Err);
                if (Err.response.status === 404) {
                  setTimeout(() => {
                    axios(Req)
                      .then((Res) => {
                        handleAfterCandidateRecomActions(Res, RequestId);
                      })
                      .catch((Err) => {
                        console.log(Err);
                        if (Err.response.status === 404) {
                          setTimeout(() => {
                            axios(Req)
                              .then((Res) => {
                                handleAfterCandidateRecomActions(
                                  Res,
                                  RequestId
                                );
                              })
                              .catch((Err) => {
                                console.log(Err);
                                if (Err.response.status === 404) {
                                  requestCandidateRecommendationsWithoutFilter(
                                    RequestId
                                  );
                                }
                              });
                          }, 2500);
                        }
                      });
                  }, 1500);
                }
              });
          }, 1000);
        }
      });
  };

  const handleAfterCandidateRecomActions = (Res, RequestId) => {
    setShowMoreRecommendationsIsOpen(true);
    if (Res.data.length === 0) {
      requestCandidateRecommendationsWithoutFilter(RequestId);
    } else {
      setRecommendationListIsOpen(true);
      let List = [];
      Res.data.map((Item) => {
        Item.candidate.main_id = Item.id;
        Item.candidate.similarity = Item.similarity;
        List.push(Item.candidate);
      });
      setRecommendations([...List].splice(0, 4));
      setAdditionalCandidates({
        set_1: [...List].splice(4, 3),
        set_2: [...List].splice(7, 4),
        set_3: [...List].splice(11, 6),
      });
    }
    scrollChat();
  };

  const handleAfterCandidateRecomActionsWithoutFilter = (Res) => {
    setRecommendationListIsOpen(true);
    let List = [];
    if (Res.data.length === 0 || !Res.data) {
      handleNoCandidateFound();
      setShowMoreRecommendationsIsOpen(false);
      return;
    }
    Res.data.map((Item) => {
      Item.candidate.main_id = Item.id;
      Item.candidate.similarity = Item.similarity;
      List.push(Item.candidate);
    });
    setRecommendations([...List].splice(0, 4));
    setAdditionalCandidates({
      set_1: [...List].splice(4, 3),
      set_2: [...List].splice(7, 4),
      set_3: [...List].splice(11, 6),
    });
  };

  const requestCandidateRecommendationsWithoutFilter = (RequestId) => {
    setIndicatorIsShown(true);
    setTimeout(() => {
      setIndicatorIsShown(false);
    }, 600);

    let FilterParam = "?ignoreFilter=true";
    let RequestIdParam = RequestId
      ? `&requestId=${RequestId}`
      : `&requestId=${SavedRequestId}`;
    let ReqURL =
      Config.PositionServiceURL +
      "/api/position/chatbot-candidates" +
      FilterParam +
      RequestIdParam;
    if (JPAType === "project") {
      ReqURL =
        Config.ProjectServiceURL +
        "/api/project/chatbot-candidates" +
        FilterParam +
        RequestIdParam;
    } else if (JPAType === "activity") {
      ReqURL =
        Config.ActivityServiceURL +
        "/api/activity/chatbot-candidates" +
        FilterParam +
        RequestIdParam;
    }
    let Req = {
      method: "GET",
      baseURL: window._env_.API_URL + ReqURL,
      headers: {
        Authorization: "Bearer " + window.localStorage.getItem("Token"),
      },
    };

    axios(Req)
      .then((Res) => {
        console.log(Res);
        setConversationMessages([
          ...ConversationMessages,
          {
            content: translateText("chatbot_skip_search_criteria"),
            isMe: false,
            dateTime: new Date().getTime(),
          },
        ]);
        handleAfterCandidateRecomActionsWithoutFilter(Res);
      })
      .catch((Err) => {
        console.log(Err.response);
        setPlaceholderText(translateText("write_a_message"));

        if (Err.response.status === 404) {
          setTimeout(() => {
            axios(Req)
              .then((Res) => {
                console.log(Res);
                handleAfterCandidateRecomActionsWithoutFilter(Res);
              })
              .catch((Err) => {
                console.log(Err);
                if (Err.response.status === 404) {
                  setTimeout(() => {
                    axios(Req)
                      .then((Res) => {
                        console.log(Res);
                        handleAfterCandidateRecomActionsWithoutFilter(Res);
                      })
                      .catch((Err) => {
                        console.log(Err);
                        if (Err.response.status === 404) {
                          setTimeout(() => {
                            axios(Req)
                              .then((Res) => {
                                console.log(Res);
                                handleAfterCandidateRecomActionsWithoutFilter(
                                  Res
                                );
                              })
                              .catch((Err) => {
                                console.log(Err);
                                if (Err.response.status === 404) {
                                  handleNoCandidateFound();
                                }
                              });
                          }, 2500);
                        }
                      });
                  }, 1500);
                }
              });
          }, 1000);
        }
      });
  };

  const requstJPARecommendations = (
    RequestId,
    WillNotShowEmptyState,
    Location
  ) => {
    setPlaceholderText(translateText("write_a_message"));

    let FilterParam = "?ignoreFilter=false";
    //if RequestId is given in function args, then use it
    //else if RequestIs is not given in function args but exist in state, then use SavedRequestId
    //else no need params
    let RequestIdParam = RequestId
      ? `&requestId=${RequestId}`
      : SavedRequestId
      ? `&requestId=${SavedRequestId}`
      : "";
    let ReqURL =
      Config.PositionServiceURL +
      "/api/position/chatbot-recommendation" +
      FilterParam +
      RequestIdParam;
    if (JPAType === "project") {
      ReqURL =
        Config.ProjectServiceURL +
        "/api/project/chatbot-recommendation" +
        FilterParam +
        RequestIdParam;
    } else if (JPAType === "activity") {
      ReqURL =
        Config.ActivityServiceURL +
        "/api/activity/chatbot-recommendation" +
        FilterParam +
        RequestIdParam;
    }

    let Req = {
      method: "GET",
      baseURL: window._env_.API_URL + ReqURL,
      headers: {
        Authorization: "Bearer " + window.localStorage.getItem("Token"),
      },
    };

    setIndicatorIsShown(true);

    axios(Req)
      .then((Res) => {
        console.log(Res);
        handleAfterJPARecomActions(Res, RequestId, undefined, Location);
      })
      .catch((Err) => {
        console.log(Err);
        setIndicatorIsShown(false);
        // 404 status is defined for the case when the recommendations are not ready yet, so we need to retry
        if (Err.response.status === 404) {
          // retry
          setTimeout(() => {
            axios(Req)
              .then((Res) => {
                console.log(Res);
                handleAfterJPARecomActions(
                  Res,
                  RequestId,
                  WillNotShowEmptyState,
                  Location
                );
              })
              .catch((Err) => {
                console.log(Err);
                if (Err.response.status === 404) {
                  // retry
                  setTimeout(() => {
                    axios(Req)
                      .then((Res) => {
                        console.log(Res);
                        handleAfterJPARecomActions(
                          Res,
                          RequestId,
                          WillNotShowEmptyState,
                          Location
                        );
                      })
                      .catch((Err) => {
                        if (Err.response.status === 404) {
                          // retry
                          setTimeout(() => {
                            axios(Req)
                              .then((Res) => {
                                console.log(Res);
                                handleAfterJPARecomActions(
                                  Res,
                                  RequestId,
                                  WillNotShowEmptyState,
                                  Location
                                );
                              })
                              .catch((Err) => {
                                if (Err.response.status === 404) {
                                  requstJPARecommendationsWithoutFilters(
                                    RequestId,
                                    WillNotShowEmptyState,
                                    Location
                                  );
                                }
                              });
                          }, 2500);
                        }
                      });
                  }, 1500);
                }
              });
          }, 1000);
        }
      });
  };

  // with filters
  const handleAfterJPARecomActions = (
    Res,
    RequestId,
    WillNotShowEmptyState,
    Location
  ) => {
    if (!ShowMoreJPAIsClicked) {
      setShowMoreJPAsIsOpen(true);
    }

    setIndicatorIsShown(false);
    if (Res.data.length === 0) {
      requstJPARecommendationsWithoutFilters(
        RequestId,
        WillNotShowEmptyState,
        Location
      );
    } else {
      setRecommendationListIsOpen(true);
      let Recoms = [];
      Res.data.map((Item) => {
        if (Item.position) {
          Item.position.main_id = Item.id;
          Item.position.bookmarked = Item.bookmarked;
          Item.position.applied = Item.applied;
          Item.position.reactionType = Item.reactionType;
          Item.position.revealIdentity = Item.revealIdentity;
          Recoms.push(Item.position);
        } else if (Item.project) {
          Item.project.main_id = Item.id;
          Item.project.bookmarked = Item.bookmarked;
          Item.project.applied = Item.applied;
          Item.project.reactionType = Item.reactionType;
          Item.project.revealIdentity = Item.revealIdentity;
          Recoms.push(Item.project);
        } else if (Item.activity) {
          Item.activity.main_id = Item.id;
          Item.activity.bookmarked = Item.bookmarked;
          Item.activity.applied = Item.applied;
          Item.activity.reactionType = Item.reactionType;
          Item.activity.revealIdentity = Item.revealIdentity;
          Recoms.push(Item.activity);
        }
      });
      setRecommendations([]);
      if (ShowMoreJPAIsClicked) {
        setRecommendations([...Recoms].splice(0, 8));
      } else {
        setRecommendations([...Recoms].splice(0, 4));
        setAdditionalJPAs([...Recoms].splice(4, 4));
      }
    }
  };

  // Without filters
  const handleAfterNoFilterJPARecomActions = (Res, WillNotShowEmptyState) => {
    if (!ShowMoreJPAIsClicked) {
      setShowMoreJPAsIsOpen(true);
    }

    setIndicatorIsShown(false);
    setRecommendationListIsOpen(true);
    let Recoms = [];
    Res.data.map((Item) => {
      if (Item.position) {
        Item.position.main_id = Item.id;
        Item.position.bookmarked = Item.bookmarked;
        Item.position.applied = Item.applied;
        Item.position.reactionType = Item.reactionType;
        Item.position.revealIdentity = Item.revealIdentity;
        Recoms.push(Item.position);
      } else if (Item.project) {
        Item.project.main_id = Item.id;
        Item.project.bookmarked = Item.bookmarked;
        Item.project.applied = Item.applied;
        Item.project.reactionType = Item.reactionType;
        Item.project.revealIdentity = Item.revealIdentity;
        Recoms.push(Item.project);
      } else if (Item.activity) {
        Item.activity.main_id = Item.id;
        Item.activity.bookmarked = Item.bookmarked;
        Item.activity.applied = Item.applied;
        Item.activity.reactionType = Item.reactionType;
        Item.activity.revealIdentity = Item.revealIdentity;
        Recoms.push(Item.activity);
      }
    });
    setRecommendations([]);
    if (ShowMoreJPAIsClicked) {
      setRecommendations([...Recoms].splice(0, 8));
    } else {
      setRecommendations([...Recoms].splice(0, 4));
      setAdditionalJPAs([...Recoms].splice(4, 4));
    }

    if (Res.data.length === 0 || !Res.data) {
      if (!WillNotShowEmptyState) {
        setConversationMessages([
          ...ConversationMessages,
          {
            content: translateText("chatbot_no_results"),
            isMe: false,
            dateTime: new Date().getTime(),
          },
        ]);
      }
      setShowMoreJPAsIsOpen(false);
    }
  };

  const requstJPARecommendationsWithoutFilters = (
    RequestId,
    WillNotShowEmptyState,
    Location
  ) => {
    setIndicatorIsShown(true);
    let FilterParam = "?ignoreFilter=true";
    let RequestIdParam = RequestId
      ? `&requestId=${RequestId}`
      : `&requestId=${SavedRequestId}`;
    let ReqURL =
      Config.PositionServiceURL +
      "/api/position/chatbot-recommendation" +
      FilterParam +
      RequestIdParam;
    if (JPAType === "project") {
      ReqURL =
        Config.ProjectServiceURL +
        "/api/project/chatbot-recommendation" +
        FilterParam +
        RequestIdParam;
    } else if (JPAType === "activity") {
      ReqURL =
        Config.ActivityServiceURL +
        "/api/activity/chatbot-recommendation" +
        FilterParam +
        RequestIdParam;
    }
    let Req = {
      method: "GET",
      baseURL: window._env_.API_URL + ReqURL,
      headers: {
        Authorization: "Bearer " + window.localStorage.getItem("Token"),
      },
    };

    axios(Req)
      .then((Res) => {
        console.log(Res);
        // this condition will prevent the no results message from being pushed to array and displayed more than once
        if (
          [...ConversationMessages].pop().content !==
          translateText("chatbot_skip_search_criteria")
        ) {
          // when a quick reply has been selected for the question about relocation, tere are 2 situations:
          // 1) if the yes/no option is selected (document.getElementById("last-fast-reply").value)
          // 2) if a location name has been selected after clicking no and having to select a location name
          // The variable Location wil be set based on that and set in the request.
          setConversationMessages([
            ...ConversationMessages,
            {
              content: Location
                ? Location
                : document.getElementById("last-fast-reply").value,
              isMe: true,
              dateTime: new Date().getTime(),
            },
            {
              content: translateText("chatbot_skip_search_criteria"),
              isMe: false,
              dateTime: new Date().getTime(),
            },
          ]);
        }
        handleAfterNoFilterJPARecomActions(Res, WillNotShowEmptyState);
      })
      .catch((Err) => {
        console.log(Err);
        // 404 status is defined for the case when the recommendations are not ready yet, so we need to retry
        if (Err.response && Err.response.status === 404) {
          setTimeout(() => {
            axios(Req)
              .then((Res) => {
                handleAfterNoFilterJPARecomActions(Res, WillNotShowEmptyState);
              })
              .catch((Err) => {
                console.log(Err);
                if (Err.response.status === 404) {
                  setTimeout(() => {
                    axios(Req)
                      .then((Res) => {
                        handleAfterNoFilterJPARecomActions(
                          Res,
                          WillNotShowEmptyState
                        );
                      })
                      .catch((Err) => {
                        console.log(Err);
                        if (Err.response.status === 404) {
                          setTimeout(() => {
                            axios(Req)
                              .then((Res) => {
                                handleAfterNoFilterJPARecomActions(
                                  Res,
                                  WillNotShowEmptyState
                                );
                              })
                              .catch((Err) => {
                                console.log(Err);
                                setIndicatorIsShown(false);
                                setShowMoreJPAsIsOpen(false);
                                setConversationMessages([
                                  ...ConversationMessages,
                                  {
                                    content:
                                      translateText("chatbot_no_results"),
                                    isMe: false,
                                    dateTime: new Date().getTime(),
                                  },
                                ]);
                              });
                          }, 2500);
                        }
                      });
                  }, 1500);
                }
              });
          }, 1000);
        }
        setIndicatorIsShown(false);
        setShowMoreJPAsIsOpen(false);
      });
  };

  const showMoreJPAs = () => {
    setShowMoreJPAIsClicked(true);
    setRecommendations(Recommendations.concat(AdditionalJPAs));
    setShowMoreJPAsIsOpen(false);
  };

  const searchTitles = (JPAType) => {
    let SearchParam = "";
    let Value = document.getElementById("chatbot-input").value;
    if (Value.length > 0) {
      SearchParam = "?titleLike=" + Value;
    }
    let ReqURL =
      Config.PositionServiceURL +
      "/api/position/find-all-positions" +
      SearchParam;
    if (JPAType === "project") {
      ReqURL =
        Config.ProjectServiceURL +
        "/api/project/find-all-projects" +
        SearchParam;
    } else if (JPAType === "activity") {
      ReqURL =
        Config.ActivityServiceURL +
        "/api/activity/find-all-activities" +
        SearchParam;
    }

    let Req = {
      method: "GET",
      baseURL: window._env_.API_URL + ReqURL,
      headers: {
        Authorization: "Bearer " + window.localStorage.getItem("Token"),
      },
    };
    axios(Req)
      .then((Res) => {
        console.log(Res);
        setAutofillResults(Res.data);
      })
      .catch((Err) => {
        console.log(Err);
      });
  };

  const searchSkills = () => {
    // this is to activate the X displayed in front of the skills
    if (SkillSelectionIsDone) {
      setSkillSelectionIsDone(false);
    }

    let Req = {
      method: "POST",
      baseURL: window._env_.API_URL + Config.AuthBaseURL + "/api/skill/search",
      headers: {
        Authorization: "Bearer " + window.localStorage.getItem("Token"),
      },
      data: {
        criteria: {
          titleLike: document.getElementById("chatbot-input").value,
        },
        start: 0,
        size: 1000,
      },
    };
    axios(Req)
      .then((Res) => {
        console.log(Res);
        let SkillTitles = [];
        Res.data.results.map((Skill) => {
          if (SelectedSkills.indexOf(Skill.title) === -1) {
            SkillTitles.push(Skill.title);
          }
        });
        setAutofillResults(SkillTitles);
        setPlaceholderText(translateText("chatbot_enter_skill_character"));
      })
      .catch((Err) => {
        console.log(Err);
      });
  };

  const searchLocations = () => {
    let SearchParam = "";
    let Value = document.getElementById("chatbot-input").value;
    if (Value.length > 0) {
      SearchParam = "?titleLike=" + Value;
    }

    let ReqURL =
      Config.PositionServiceURL + "/api/position/preset/find-all-cities";
    if (JPAType === "project") {
      ReqURL = Config.ProjectServiceURL + "/api/project/preset/find-all-cities";
    } else if (JPAType === "activity") {
      ReqURL =
        Config.ActivityServiceURL + "/api/activity/preset/find-all-cities";
    }

    let Req = {
      method: "GET",
      baseURL: window._env_.API_URL + ReqURL + SearchParam,
      headers: {
        Authorization: "Bearer " + window.localStorage.getItem("Token"),
      },
    };

    axios(Req)
      .then((Res) => {
        console.log(Res);
        setAutofillResults(Res.data);
        setPlaceholderText(translateText("chatbot_enter_city_character"));
      })
      .catch((Err) => {
        console.log(Err);
      });
  };

  const toggleInputChange = (e) => {
    if (AutofillIsOpen) {
      if (AutofillType === "TITLE") {
        searchTitles(JPAType);
      } else if (AutofillType === "SKILLS") {
        searchSkills();
        if (e.target.value.length > 0) {
          setNotofierIsShown(false);
        }
      } else if (AutofillType === "LOCATION") {
        searchLocations();
      }
    }

    resetBotTimeouts();
  };

  const selectSkills = (Skill) => {
    let Selected = [...SelectedSkills];

    if (Selected.length < 5) {
      Selected.push(Skill);

      let Unselected = AutofillResults.filter((Item) => {
        return Item !== Skill;
      });

      setAutofillResults(Unselected);

      setSelectedSkills(Selected);

      setConversationMessages([
        ...ConversationMessages,
        {
          isMe: true,
          isTemp: true,
          content: Skill,
          dateTime: new Date().getTime(),
          senderId: props.UserInfo.id + `(${DeviceInfo})`,
          IsSkill: true,
        },
      ]);
    }
  };

  const handleDoneAddingSkills = () => {
    setSkillSelectionIsDone(true);
    document.getElementById("chatbot-input").value = "";
    let Skills = SelectedSkills.join("|");
    sendSelectedSkills(Skills);
    setAutofillSlotName("skills");
  };

  const handleShowMore = () => {};

  const sendSelectedSkills = (Skills) => {
    let Req = {
      method: "POST",
      baseURL: window._env_.RASA_URL + "/webhooks/rest/webhook",
      headers: {
        "Content-Type": "application/json",
      },
      data: {
        sender: props.UserInfo.id + `(${DeviceInfo})`,
        message: '/inform{"skills":"' + Skills.toString() + '"}',
        metadata: { token: window.localStorage.getItem("Token") },
      },
    };

    axios(Req)
      .then((Res) => {
        console.log(Res);
        let NewMessages = [];
        Res.data.map((Message) => {
          if (Message.text) {
            NewMessages.push({
              content: Message.text,
              isMe: false,
              dateTime: new Date().getTime(),
            });
          }
        });
        setSelectedSkills([]);
        setAutofillResults([]);
        setAutofillIsOpen(false);
        setPlaceholderText(translateText("write_a_message"));
        setConversationMessages([
          ...ConversationMessages,
          {
            content: document.getElementById("chatbot-input").value,
            isMe: true,
            dateTime: new Date().getTime(),
          },
          ...NewMessages,
        ]);
        document.getElementById("chatbot-input").value = "";
      })
      .catch((Err) => {
        console.log(Err);
      });
  };

  const selectLanguage = (Lang) => {
    let RemainingOptions = Autofill.languages.filter((Item) => {
      return Item !== Lang;
    });
    setAutofill({
      selected_languages: [...Autofill.selected_languages, Lang],
      isOpen: Autofill.isOpen,
      type: Autofill.type,
      languages: RemainingOptions,
      locations: Autofill.locations,
      skills: Autofill.skills,
      selected_locations: Autofill.selected_locations,
      selected_skills: Autofill.selected_skills,
    });
    setConversationMessages([
      ...ConversationMessages,
      {
        isMe: true,
        isTemp: true,
        content: Lang,
        senderId: props.UserInfo.id,
        dateTime: new Date().getTime(),
      },
    ]);
  };

  const selectLocation = (Loc) => {
    let Req = {
      method: "POST",
      baseURL: window._env_.RASA_URL + "/webhooks/rest/webhook",
      headers: {
        "Content-Type": "application/json",
      },
      data: {
        sender: props.UserInfo.id + `(${DeviceInfo})`,
        message: '/inform{"location":"' + Loc + '"}',
        metadata: { token: window.localStorage.getItem("Token") },
      },
    };
    document.getElementById("chatbot-input").value = Loc;

    // message: "/inform{\"location\":\""+ Loc +"\"}",
    axios(Req)
      .then((Res) => {
        console.log(Res);
        let NewMessages = [];
        setAutofillIsOpen(false);

        Res.data.map(async (Message) => {
          if (Message.text) {
            NewMessages.push({
              content: Message.text,
              isMe: false,
              dateTime: new Date().getTime(),
            });
            if (Message.buttons) {
              // make sure quick reply message is set before showing
              await setQuickReplyMessage(Message.buttons);
              setQuickReplyIsOpen(true);
            }
          } else if (Message.custom && Message.custom.data.select) {
            setJPAType(Message.custom.data.select.item_type);
            setAutofillIsOpen(true);
            setAutofillType(Message.custom.data.select.item.toUpperCase());
            setAutofillSlotName(Message.custom.data.select.slot_name);
            if (Message.custom.data.select.item === "title") {
              setAutofillResults([]);
              searchTitles(Message.custom.data.select.item_type);
            } else if (Message.custom.data.select.item === "skills") {
              setAutofillResults([]);
              searchSkills();
            } else if (Message.custom.data.select.item === "location") {
              setAutofillResults([]);
              searchLocations();
            }
          } else if (Message.custom && Message.custom.data.info) {
            var FinalInfo = JSON.parse(
              Message.custom.data.info.info_description
            );
            const RequestId = FinalInfo.filters.request_id;
            setSavedRequestId(RequestId);
            if (FinalInfo.is_for_candidate) {
              setIsLookingForJPA(false);
              requestCandidateRecommendations(RequestId);
            } else {
              setIsLookingForJPA(true);
              requstJPARecommendations(RequestId, undefined, Loc);
            }
          }
        });

        setConversationMessages([
          ...ConversationMessages,
          {
            content: document.getElementById("chatbot-input").value,
            isMe: true,
            dateTime: new Date().getTime(),
          },
          ...NewMessages,
        ]);
        document.getElementById("chatbot-input").value = "";
      })
      .catch((Err) => {
        console.log(Err);
      });
  };

  const removeSelectedTempOption = (Opt) => {
    setAutofillResults([Opt, ...AutofillResults]);

    if (AutofillType === "SKILLS") {
      let Selected = SelectedSkills.filter((Item) => {
        return Item !== Opt;
      });
      setSelectedSkills(Selected);
    }

    let NewConversationMessages = ConversationMessages.filter((Message) => {
      return Message.content !== Opt;
    });
    setConversationMessages(NewConversationMessages);
  };

  const handleHeaderArrowClick = () => {
    setShowHeaderBanner(Boolean(!showHeaderBanner));
    localStorage.setItem("showChatbotOnBoardingBanner", "");
  };
  const handleJpaSave = () => {};

  const handleJpaMoreDetail = () => {
    setCandidates({ ...Candidates, showJpaDetails: true });
  };

  const selectCategory = (Category) => {
    var Message = document.getElementById("chatbot-input").value;
    let Req = {
      method: "POST",
      baseURL: window._env_.RASA_URL + "/webhooks/rest/webhook",
      headers: {
        "Content-Type": "application/json",
      },
      data: {
        sender: props.UserInfo.id + `(${DeviceInfo})`,
        message: '/inform{"jpa_category":"' + Category + '"}',
        metadata: { token: window.localStorage.getItem("Token") },
      },
    };
    document.getElementById("chatbot-input").value = Category;

    setTimeout(() => {
      setIndicatorIsShown(true);
    }, 200);
    setConversationMessages([
      ...ConversationMessages,
      {
        content: switchCategory(Category),
        isMe: true,
        dateTime: new Date().getTime(),
      },
    ]);
    document.getElementById("chatbot-input").value = "";

    axios(Req)
      .then((Res) => {
        console.log(Res);
        setAutofillIsOpen(false);
        setRecommendationListIsOpen(false);
        setTotalRecommendationElements(0);
        setQuickReplyIsOpen(false);
        setQuickReplyMessage([]);
        setShowMoreJPAsIsOpen(false);
        setTripleBtnIsShown(false);
        setErrorMessage({ ...ErrorMessage, IsOpen: false });
        setTimeout(() => {
          let NewMessages = [];
          Res.data.map((Message) => {
            if (Message.text) {
              NewMessages.push(
                {
                  content: switchCategory(Category),
                  isMe: true,
                  dateTime: new Date().getTime(),
                },
                {
                  content: Message.text,
                  isMe: false,
                  dateTime: new Date().getTime(),
                }
              );
              if (Message.buttons) {
                if (Message.buttons.length === 2) {
                  // make sure quick reply message is set before showing
                  setQuickReplyMessage(Message.buttons);
                  setQuickReplyIsOpen(true);
                } else if (Message.buttons.length === 3) {
                  setTripleBtnIsShown(true);
                }
              }
            } else if (Message.custom && Message.custom.data.select) {
              setJPAType(Message.custom.data.select.item_type);
              setAutofillIsOpen(true);
              setAutofillType(Message.custom.data.select.item.toUpperCase());
              setAutofillSlotName(Message.custom.data.select.slot_name);
              if (Message.custom.data.select.item === "title") {
                setAutofillResults([]);
                searchTitles(Message.custom.data.select.item_type);
              } else if (Message.custom.data.select.item === "skills") {
                setAutofillResults([]);
                searchSkills();
              } else if (Message.custom.data.select.item === "location") {
                setAutofillResults([]);
                searchLocations();
              }
            } else if (
              Message?.custom?.data?.info?.info === "show_me_requested"
            ) {
              const FinalInfo = JSON.parse(
                Message.custom.data.info.info_description
              );
              // reaction_type = position | project | activity
              setReactionType(FinalInfo.reaction_type);
              setJPACategoryType(FinalInfo.category);
              setJPAType(FinalInfo.category);
              if (FinalInfo.reaction_type === "like") {
                requestShowLikedJPA(FinalInfo.category, 0, true);
              }
              if (
                FinalInfo.reaction_type === "Applications" ||
                FinalInfo.reaction_type === "apply"
              ) {
                requestShowAppliedJPA(FinalInfo.category, 0, true);
              }
            } else if (Message.custom && Message.custom.data.info) {
              requstJPARecommendations();
            }
          });

          setConversationMessages([
            ...ConversationMessages,
            {
              content: Message,
              isMe: true,
              dateTime: new Date().getTime(),
            },
            ...NewMessages,
          ]);

          setIndicatorIsShown(false);
        }, 1000);
      })
      .catch((Err) => {
        console.log(Err);
      });
  };

  const switchCategory = (Category) => {
    if (Category === "position") {
      return "Job";
    } else if (Category === "project") {
      return "Project";
    } else {
      return "Activity";
    }
  };

  const handleShowMoreCandidates = () => {
    if (MoreCandidatesCount === 3) {
      setRecommendations([...Recommendations, ...AdditionalCandidates.set_1]);
      setMoreCandidatesCount(4);
    } else if (MoreCandidatesCount === 4) {
      setRecommendations([...Recommendations, ...AdditionalCandidates.set_2]);
      setMoreCandidatesCount(6);
    } else if (MoreCandidatesCount === 6) {
      setRecommendations([...Recommendations, ...AdditionalCandidates.set_3]);
      setShowMoreRecommendationsIsOpen(false);
      setMoreCandidatesCount(3);
    }
  };

  const handleShowMoreCandidatesUntilDone = () => {
    if (ReactionType === "like") {
      requestShowLikedJPA(JPACategoryType, Recommendations.length, false);
      return;
    }
    requestShowAppliedJPA(JPACategoryType, Recommendations.length, false);
  };

  const handleClose = () => {
    document.getElementById("chatbot-main").classList.remove("is-open");
    props.SetIsOpen(false);
    setTimeout(() => {
      props.Close();
    }, 250);
  };

  const handleDeleteConversation = () => {
    setAutofillIsOpen(false);
    setRecommendationListIsOpen(false);
    setTotalRecommendationElements(0);
    setQuickReplyIsOpen(false);
    setQuickReplyMessage([]);
    setShowMoreJPAsIsOpen(false);
    setTripleBtnIsShown(false);
    setShowMoreRecommendationsIsOpen(false);
    setConversationMessages([]);
    setErrorMessage({ ...ErrorMessage, IsOpen: false });
    restartChatbot();
  };

  const handleNoCandidateFound = () => {
    setConversationMessages([
      ...ConversationMessages,
      {
        content: translateText("chatbot_no_results"),
        isMe: false,
        dateTime: new Date().getTime(),
      },
    ]);
    setIndicatorIsShown(false);
  };

  const handleJpaApply = (IsAnonymous) => {
    let ReqURL =
      Config.PositionServiceURL +
      "/api/position/chatbot-recommendation/application";
    if (JPAType === "project") {
      ReqURL =
        Config.ProjectServiceURL +
        "/api/project/chatbot-recommendation/application";
    } else if (JPAType === "activity") {
      ReqURL =
        Config.ActivityServiceURL +
        "/api/activity/chatbot-recommendation/application";
    }
    let Req = {
      method: "POST",
      baseURL: window._env_.API_URL + ReqURL,
      headers: {
        Authorization: "Bearer " + window.localStorage.getItem("Token"),
      },
      data: {
        id: JPAItem.main_id,
        isAnonymous: IsAnonymous,
      },
    };
    console.log(Req.data);
    axios(Req)
      .then((Res) => {
        console.log(Res);
        requstJPARecommendations(undefined, false);
      })
      .catch((Err) => {
        console.log(Err.response);
      });
  };

  const requestShowLikedJPA = (category, start = 0, firstRequest = false) => {
    const Req = {
      method: "POST",
      baseURL:
        window._env_.API_URL +
        `/${category}-service/api/${category}/recommendation/search/reaction`,
      headers: {
        Authorization: "Bearer " + window.localStorage.getItem("Token"),
      },
      data: {
        start: start,
        size: 4,
        criteria: {},
        sorts: [
          {
            fieldName: "createdTime",
            direction: "DESC",
          },
        ],
      },
    };
    axios(Req).then(async (Res) => {
      setRecommendationListIsOpen(true);
      if (Res.data.results) {
        for (let i = 0; i < Res.data.results.length; i++) {
          Res.data.results[i].main_id = Res.data.results[i].id;
          Res.data.results[i] = {
            ...Res.data.results[i],
            ...Res.data.results[i][category],
          };
        }
      }
      if (Res.data.results.length === 0) {
        setConversationMessages((PrevMessage) => [
          ...PrevMessage,
          {
            content: translateText("chatbot_no_results"),
            isMe: false,
          },
        ]);
        setRecommendations([]);
        setTotalRecommendationElements(0);
        return;
      }
      if (firstRequest) {
        setRecommendations(Res.data.results);
      } else {
        setRecommendations([...Recommendations, ...Res.data.results]);
      }
      setTotalRecommendationElements(Res.data.totalElements);
    });
  };

  const requestShowAppliedJPA = (category, start = 0, firstRequest = false) => {
    const Req = {
      method: "POST",
      baseURL:
        window._env_.API_URL +
        `/${category}-service/api/${category}/recommendation/search/application`,
      headers: {
        Authorization: "Bearer " + window.localStorage.getItem("Token"),
      },
      data: {
        start: start,
        size: 4,
        criteria: {},
        sorts: [
          {
            fieldName: "createdTime",
            direction: "DESC",
          },
        ],
      },
    };
    axios(Req).then(async (Res) => {
      setRecommendationListIsOpen(true);
      if (Res.data.results) {
        for (let i = 0; i < Res.data.results.length; i++) {
          Res.data.results[i].main_id = Res.data.results[i].id;
          Res.data.results[i] = {
            ...Res.data.results[i],
            ...Res.data.results[i][category],
          };
        }
      }
      if (Res.data.results.length === 0) {
        setConversationMessages((PrevMessage) => [
          ...PrevMessage,
          {
            content: translateText("chatbot_no_results"),
            isMe: false,
            dateTime: new Date().getTime(),
          },
        ]);
        setRecommendations([]);
        setTotalRecommendationElements(0);
        return;
      }
      if (firstRequest) {
        setRecommendations(Res.data.results);
      } else {
        setRecommendations([...Recommendations, ...Res.data.results]);
      }
      setTotalRecommendationElements(Res.data.totalElements);
    });
  };

  const handleJPADetails = (Bool, JPAItem) => {
    setJPADetailsIsOpen(Bool);
    setJPAItem(JPAItem);
  };

  const handleMainAreaClicks = (e) => {
    e.stopPropagation();
    resetBotTimeouts();
  };

  const handleTimeoutAccept = () => {
    resetBotTimeouts();
    setTimeoutModalIsOpen(false);
  };

  const handleShowError = (bool) => {
    setErrorMessage({ ...ErrorMessage, IsOpen: bool });
  };

  const handleJPATranslation = (jpaName) => {
    switch (jpaName) {
      case "activity":
        return "activities";
      case "project":
        return "projects";
      default:
        return "positions";
    }
  };
  return (
    <>
      <input hidden id="last-fast-reply" type="text" />
      {TimeoutModalIsOpen ? (
        <TimeoutModal
          Cancel={() => setTimeoutModalIsOpen(false)}
          Accept={() => handleTimeoutAccept()}
          AlertInfo={
            translateText("your_session_will_end_in") +
            " " +
            parseInt(TimeoutDuration - TimeoutWarning) +
            " " +
            translateText("minutes") +
            ". " +
            translateText("chatbor_inactivity_text")
          }
          AlertText={translateText("session_timeout_warning")}
          MinutesLeft={TimeoutDuration - TimeoutWarning}
          translateText={(LabelId) => translateText(LabelId)}
        />
      ) : null}
      {JPADetailsIsOpen ? (
        <JpaDetailsModal
          jpaDetails={JPAItem}
          Close={() => setJPADetailsIsOpen(false)}
          Apply={(IsAnonymous) => handleJpaApply(IsAnonymous)}
          LangData={props.LangData}
        />
      ) : null}
      <div
        className="overlay"
        style={
          !props.IsOpen
            ? { zIndex: -9999, opacity: 0, pointerEvents: "none" }
            : null
        }
      ></div>
      <div
        className="outline"
        style={
          !props.IsOpen
            ? { zIndex: -9999, opacity: 0, pointerEvents: "none" }
            : null
        }
        onClick={() => handleClose()}
      >
        <section
          className={props.IsOpen ? "chatbot-main is-open" : "chatbot-main"}
          id="chatbot-main"
          ref={chatBotElement}
          onClick={(e) => handleMainAreaClicks(e)}
        >
          {/*Chatbot Head*/}
          <ChatbotHeader
            showHeaderBanner={showHeaderBanner}
            onHeaderArrowClick={handleHeaderArrowClick}
            Close={() => handleClose()}
            message={headerBannerMessage}
            LangData={props.LangData}
            ReqDeleteConversation={() => handleDeleteConversation()}
            SetChatbotType={(Type) => props.SetChatbotType(Type)}
          />
          {/*chatbot content*/}
          <div className="chatbot-content">
            {/*chatbot Messages*/}
            <>
              {ConversationMessages !== undefined ? (
                <ChatMessages
                  ConverstionMessages={ConversationMessages}
                  LangData={props.LangData}
                  showCandidates={RecommendationListIsOpen}
                  candidateList={Candidates.list}
                  savedContents={Candidates.savedContents}
                  isJpa={IsLookingForJPA}
                  Recommendations={Recommendations}
                  UserInfo={props.UserInfo}
                  RemoveOption={(Opt) => removeSelectedTempOption(Opt)}
                  handleJpaSave={() => handleJpaSave()}
                  handleJpaApply={() => handleJpaApply(undefined)}
                  handleJpaMoreDetail={() => handleJpaMoreDetail()}
                  JPAType={JPAType}
                  JPACategoryType={JPACategoryType}
                  RefreshRecommendations={() => requstJPARecommendations()}
                  UniqueTitles={UniqueTitles}
                  XIsShown={!SkillSelectionIsDone}
                  AutofillIsOpen={AutofillIsOpen}
                  SetDetailsIsOpen={(Bool, JPAItem) =>
                    handleJPADetails(Bool, JPAItem)
                  }
                  ChangedCandidateBookmark={props.ChangedCandidateBookmark}
                  ChangedJPAReaction={props.ChangedJPAReaction}
                  handleResetTimeout={() => resetBotTimeouts()}
                  SavedRequestId={SavedRequestId}
                  ShowError={(bool) => handleShowError(bool)}
                />
              ) : null}
            </>
            {IndicatorIsShown ? <TypingIndicator /> : null}
            {QuickReplyIsOpen ? (
              <>
                <div className="chatbot-suggestion-quick_reply mt-2">
                  <div
                    className="quick_reply-box"
                    onClick={() =>
                      sendQuickReply(
                        QuickReplyMessage[0] &&
                          QuickReplyMessage[0].title === "Likes"
                          ? "Likes"
                          : "Yes"
                      )
                    }
                  >
                    {QuickReplyMessage[0] &&
                    QuickReplyMessage[0].title === "Likes"
                      ? translateText("likes")
                      : translateText("yes")}
                  </div>
                  <div
                    className="quick_reply-box"
                    onClick={() =>
                      sendQuickReply(
                        QuickReplyMessage[1] &&
                          QuickReplyMessage[1].title === "Applications"
                          ? "Applications"
                          : "No"
                      )
                    }
                  >
                    {QuickReplyMessage[1] &&
                    QuickReplyMessage[1].title === "Applications"
                      ? translateText("applications")
                      : translateText("no")}
                  </div>
                </div>
              </>
            ) : null}
            {SelectSearchTypeIsOpen ? (
              <>
                <div className="chatbot-suggestion-quick_reply mt-2">
                  <div
                    className="quick_reply-box"
                    onClick={() => sendQuickReply("Vacancy")}
                  >
                    {translateText("vacancy")}
                  </div>
                  <div
                    className="quick_reply-box"
                    onClick={() => sendQuickReply("Candidate")}
                  >
                    {translateText("candidate")}
                  </div>
                </div>
              </>
            ) : null}
            {TripleBtnIsShown ? (
              <>
                <div className="chatbot-suggestion-quick_reply mt-2">
                  <div
                    className="quick_reply-box"
                    onClick={() => selectCategory("position")}
                  >
                    {translateText("job")}
                  </div>
                  <div
                    className="quick_reply-box"
                    onClick={() => selectCategory("project")}
                  >
                    {translateText("project")}
                  </div>
                  <div
                    className="quick_reply-box"
                    onClick={() => selectCategory("activity")}
                  >
                    {translateText("activity")}
                  </div>
                </div>
              </>
            ) : null}
            {ShowMoreJPAsIsOpen &&
            Recommendations.concat(AdditionalJPAs).length > 4 ? (
              <>
                <div className="chatbot-suggestion-quick_reply mt-2">
                  <div
                    className="quick_reply-box"
                    onClick={() => showMoreJPAs()}
                  >
                    {AdditionalJPAs.length === 4
                      ? translateText("chatbot_show_4_more")
                      : translateText("chatbot_show_more")}
                  </div>
                </div>
              </>
            ) : null}
            {SelectedSkills.length === 5 ? (
              <>
                <div className="chatbot-suggestion-quick_reply mt-2">
                  <div
                    className="quick_reply-box"
                    onClick={() => handleDoneAddingSkills()}
                  >
                    {translateText("done")}
                  </div>
                </div>
              </>
            ) : null}
            {ShowMoreRecommendationsIsOpen &&
            Recommendations.concat(AdditionalCandidates).length > 4 ? (
              <>
                <div className="chatbot-suggestion-quick_reply mt-2">
                  <div
                    className="quick_reply-box"
                    onClick={() => handleShowMoreCandidates()}
                  >
                    {translateText("show")} {MoreCandidatesCount + " "}
                    {translateText("more_candidates")}
                  </div>
                </div>
              </>
            ) : null}
            {totalRecommendationElements > Recommendations.length ? (
              <div className="chatbot-suggestion-quick_reply mt-2">
                <div
                  className="quick_reply-box"
                  onClick={() => handleShowMoreCandidatesUntilDone()}
                >
                  {translateText("show")}{" "}
                  {totalRecommendationElements - Recommendations.length >= 4
                    ? "4"
                    : totalRecommendationElements - Recommendations.length}{" "}
                  {translateText("more")}{" "}
                  {translateText(handleJPATranslation(JPACategoryType))}
                </div>
              </div>
            ) : null}
            {/*chatbot suggestion*/}
            {suggestion.show ? (
              <ShowSuggestions
                isQuickReplies={suggestion.isQuickReplies}
                name={suggestion.name}
                onShowMore={() => handleShowMore()}
                LangData={props.LangData}
              />
            ) : null}
            {AutofillIsOpen ? (
              <AutofillComponent
                Type={AutofillType}
                Results={AutofillResults}
                SelectLanguage={(Lang) => selectLanguage(Lang)}
                SelectSkill={(Skill) => selectSkills(Skill)}
                SelectTitle={(Opt) => handleInputSubmit(undefined, true, Opt)}
                SelectLocation={(Loc) => selectLocation(Loc)}
                LangData={props.LangData}
                SelectedSkills={SelectedSkills}
              />
            ) : null}
            {ErrorMessage.IsOpen ? (
              <div className="chatbot-error-message">
                {ErrorMessage.Message}
              </div>
            ) : null}
            <ChatInput
              onInputSubmit={(e) => handleInputSubmit(e)}
              onChangeHandler={(e) => toggleInputChange(e)}
              PlaceholderText={PlaceholderText}
              LangData={props.LangData}
            />
            {NotifierIsShown ? (
              <SkillSelectNotifier
                Text={PlaceholderText}
                Close={() => setNotofierIsShown(false)}
              />
            ) : null}
          </div>
        </section>
      </div>
    </>
  );
};

export default CXBot;
